import {
  singleConceptInterface,
  singleContractInterface,
} from 'Interfaces/FDPInterfaces/tmsInterfaces';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import classes from './conceptDetails.module.scss';

const ConceptDetailsSection = ({
  mode = 'view',
  path = '',
  label = '',
  loading: _loading = false,
  isDisabled = false,
  conceptDetails,
  contractDetails,
  backTo,
  backLabel = 'Back',
}: {
  mode?: string;
  path?: string;
  label?: string;
  loading?: boolean;
  isDisabled?: boolean;
  conceptDetails: singleConceptInterface | null;
  contractDetails: singleContractInterface[] | [];
  // Opt-in Back affordance. When set, renders a small Back control to the
  // left of the concept heading that navigates to the given path. Left
  // undefined by every existing caller so their headers are unchanged —
  // only the v2 Edit screen wires it up today, but the prop is generic
  // so any future Edit/View screen can opt in by passing a target path.
  backTo?: string;
  backLabel?: string;
}) => {
  const navigate = useNavigate();

  return (
    <div className={classes.drugDetailsContainer}>
      {backTo && (
        <div className={classes.backBar}>
          <button
            type="button"
            className={classes.backBtn}
            onClick={() => navigate(backTo)}
            aria-label={backLabel}
          >
            <ArrowLeft size={14} aria-hidden />
            <span>{backLabel}</span>
          </button>
        </div>
      )}
      <div className={classes.drugDetails}>
        <h4>{conceptDetails?.concept}</h4>
        <div className={classes.contractDetailsContainer}>
          <div className={classes.leftContainer}>
            <h5>Active Contracts</h5>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <table>
              <thead>
                <th style={{ paddingRight: '3rem' }}>
                  <td style={{ paddingLeft: '1rem' }}>Contract Type</td>
                </th>
                <th style={{ paddingRight: '3rem' }}>
                  <td>Start Date</td>
                </th>
                <th style={{ paddingRight: '1rem' }}>
                  <td>End Date</td>
                </th>
              </thead>
              <tbody>
                <tr>
                  <hr />
                </tr>
                {contractDetails.map(item => {
                  return (
                    <tr>
                      <td style={{ paddingLeft: '1rem' }}>{item.ContractType}</td>
                      <td>{item.StartDate}</td>
                      <td>{item.EndDate}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {mode === 'view' ? (
          <div>
            <button
              className={classes.newPlanBtn}
              onClick={() => {
                navigate(path);
              }}
              disabled={isDisabled}
              style={
                isDisabled
                  ? {
                      backgroundColor: '#9683a9',
                      border: 'none',
                    }
                  : {}
              }
            >
              {label}
            </button>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <Accordion className={classes.conceptAccordian}>
        <AccordionTab header="Concept Details">
          <div className={classes.tableHolder}>
            <table className={classes.leftSideBar}>
              <tbody>
                <tr>
                  <td className={classes.detailsKey}>
                    {
                      <div style={{ fontWeight: 700 }}>
                        <span>GFC</span>{' '}
                        <span style={{ fontWeight: 400 }}>
                          {' - '}
                          {conceptDetails?.gfc}
                        </span>
                      </div>
                    }
                  </td>
                  <td>
                    <div className={classes.conceptIdsTableData}>
                      <span>
                        <span
                          style={{
                            fontSize: '1rem',
                            fontWeight: 700,
                            marginRight: '5px',
                          }}
                        >
                          {`RxCUI `}
                        </span>
                        {` - `}
                        <span
                          style={{
                            fontSize: '1rem',
                            fontWeight: 400,
                            marginRight: '5px',
                          }}
                        >
                          {conceptDetails?.generic_rxcui}
                        </span>
                      </span>
                      <span>
                        <span
                          style={{
                            fontSize: '1rem',
                            fontWeight: 700,
                            marginRight: '5px',
                          }}
                        >
                          {`GTIN `}
                        </span>
                        <span>{` - `}</span>
                        <span style={{ fontSize: '1rem', fontWeight: 400 }}>Null</span>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>DES Schedule</td>
                  <td className={classes.conceptIdsTableData}>{conceptDetails?.des_schedule}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>Duration & Condition</td>
                  <td className={classes.conceptIdsTableData}>
                    {conceptDetails?.duration_condition}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className={classes.rightSideBar}>
              <tbody>
                <tr>
                  <td className={classes.detailsKey}>Therapeutic Category</td>
                  <td>{conceptDetails?.therapeutic_category}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>Pharmacologic Class</td>
                  <td>{conceptDetails?.pharmacologic_class}</td>
                </tr>
                <tr>
                  <td className={classes.detailsKey}>VA Class Name</td>
                  <td>{conceptDetails?.va_class_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default ConceptDetailsSection;
